export var DictStatuses = [
  { id: "1", value: "abbey", alternatives: [] },
  { id: "9", value: "cella", alternatives: [] },
  { id: "13", value: "college", alternatives: [] },
  { id: "4", value: "convent", alternatives: [] },
  { id: "5", value: "commandery", alternatives: [] },
  { id: "7", value: "educational establishment", alternatives: [] },
  { id: "10", value: "hospital", alternatives: [] },
  { id: "14", value: "missionary station", alternatives: [] },
  { id: "2", value: "priory", alternatives: [] },
  { id: "8", value: "production establishment", alternatives: [] },
  { id: "3", value: "provostry", alternatives: [] },
  { id: "11", value: "rectory", alternatives: [] },
  { id: "6", value: "religious building", alternatives: [] },
  { id: "12", value: "residence", alternatives: [] },
  { id: "0", value: "unknown", alternatives: [""] },
  { id: "100", value: "other", alternatives: [] },
];
